"use strict";
var fails = require("../internals/fails");
module.exports = function(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function() {
    method.call(null, argument || function() {
      return 1;
    }, 1);
  });
};
